import Pair from '../models/pair';

export default Backbone.Collection.extend({
	model: Pair
});
